import http from '~/services/installation-risk-api/installation-risk-api.http';
import { InstallationRiskApi } from '~/services/installation-risk-api/installation-risk-api.types';

export default {
  getHardwareForm: async (projectId: string): Promise<InstallationRiskApi.HardwareForm> => {
    const { data } = await http.get<InstallationRiskApi.HardwareForm>(
      `/hardware/form/${projectId}`,
    );
    return data;
  },
};
